module.exports = __webpack_public_path__ + "static/media/tinyLock.9aa4c1d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tinyLock.svg
// module id = 506
// module chunks = 0